export const state = () => ({
  cart_unique_id: null,
  comparlist_unique_id: null,
});
